import { F0Box } from '@factorialco/f0-react'
import { IndicatorsList, Widget } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'
import type { IncentivesCompensationPlanPeriodFragment } from 'generated/resources/graphql'
import moment from 'moment'
import { diffBetweenDates, formatBackendDateToDayMonthYear } from 'modules/core/lib/dates'
import { PERIOD_STATUS, getPeriodStatus } from 'modules/incentives/lib/period'
import { useNavigation } from 'modules/core/hooks/useNavigation'

interface PlanDetailWidgetsProps {
  period: IncentivesCompensationPlanPeriodFragment
}

export function CompensationPlanDetailWidgets({ period }: PlanDetailWidgetsProps) {
  const { navigation } = useNavigation()

  const periodStatus = getPeriodStatus(period)
  const widgetTitle =
    periodStatus === PERIOD_STATUS.CLOSED ? '' : i18n.t('incentives.detail.period_widget.title')
  const deadline = i18n.t('incentives.detail.period_widget.deadline', {
    date: formatBackendDateToDayMonthYear(period.endsOn),
  })
  const daysRemaining = diffBetweenDates(period.endsOn, moment().format('YYYY-MM-DD'))
  const daysLabel = `${daysRemaining} ${i18n.tp('common.day', { count: daysRemaining })}`
  const content =
    periodStatus === PERIOD_STATUS.CLOSED
      ? i18n.t('incentives.detail.period_widget.closed')
      : daysLabel

  const lastExecution = period.lastExecution

  return (
    <F0Box display="grid" columns="12" gap="sm" paddingLeft="xl">
      <F0Box colSpan="12" md={{ colSpan: '6' }} lg={{ colSpan: '4' }}>
        <Widget fullHeight {...(widgetTitle ? { header: { title: widgetTitle } } : {})}>
          <IndicatorsList items={[{ content: content, label: deadline }]} />
        </Widget>
      </F0Box>
      <F0Box colSpan="12" md={{ colSpan: '6' }} lg={{ colSpan: '4' }}>
        {lastExecution?.generationStatus === 'completed' && (
          <Widget
            fullHeight
            header={{
              title: i18n.t('incentives.detail.sent_widget.title'),
              link: {
                title: i18n.t('sidebar.compensation'),
                url: navigation.compensations.fullPath(),
              },
            }}
          >
            <IndicatorsList
              items={[{ content: moment(lastExecution.executedAt).format('MMMM YYYY'), label: '' }]}
            />
          </Widget>
        )}
      </F0Box>
    </F0Box>
  )
}
